import { render, staticRenderFns } from "./acceptComplete.vue?vue&type=template&id=20042f6c&scoped=true&"
import script from "./acceptComplete.vue?vue&type=script&lang=js&"
export * from "./acceptComplete.vue?vue&type=script&lang=js&"
import style0 from "./acceptComplete.vue?vue&type=style&index=0&id=20042f6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20042f6c",
  null
  
)

export default component.exports